import UserModel from './UserModel';
import CounselorProfileModel from './CounselorProfileModel';

export default class AppointmentRequestModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    //this.approved = data.approved || false;
    // this.counselor_id = data.counselor_id || 0;

    this.counselor = new CounselorProfileModel(data.counselor);

    this.existing_patient = data.existing_patient || false;
    this.start_time = data.start_time ? new Date(data.start_time) : null;
    this.end_time = data.end_time ? new Date(data.end_time) : null;

    this.user = data.user ? new UserModel(data.user) : null;

    // todo: school name ??
  }

  get counselor_id() {
    return this.counselor.id;
  }
}
